import { Modal } from 'antd';
import React from 'react';
import AdvancedButton from '@portal/components/AdvancedButton/AdvancedButton';
import { translate } from '@portal/services/i18n';

interface KeyPortabilityModalProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  pixKey: string;
  buttonOk: () => void;
  isPortability?: boolean;
}

const KeyPortabilityModal = ({
  visible,
  setVisible,
  pixKey,
  buttonOk,
  isPortability,
}: KeyPortabilityModalProps) => {
  const handleOk = () => {
    setVisible(false);
    buttonOk();
  };

  return (
    <Modal
      open={visible}
      onCancel={() => setVisible(false)}
      footer={null}
      centered
    >
      <h2>
        {isPortability
          ? translate(
              'COMPONENTS.PIX_PORTABILITY_MODAL.PENDING_PORTABILITY_CONFIRM.TITLE'
            )
          : translate(
              'COMPONENTS.PIX_PORTABILITY_MODAL.PENDING_CLAIM_CONFIRM.TITLE'
            )}
      </h2>

      <span className="key-portability">{pixKey}</span>

      <p className="mt-3">
        {isPortability
          ? translate(
              'COMPONENTS.PIX_PORTABILITY_MODAL.PENDING_PORTABILITY_CONFIRM.TEXT.FIRST_LINE'
            )
          : translate(
              'COMPONENTS.PIX_PORTABILITY_MODAL.PENDING_CLAIM_CONFIRM.TEXT.FIRST_LINE'
            )}
      </p>

      <div className="key-portability__buttons">
        <AdvancedButton
          text={translate(
            'COMPONENTS.PIX_PORTABILITY_MODAL.PENDING_CLAIM_CONFIRM.BUTTON.OK'
          )}
          variant="contained"
          onClick={handleOk}
        />
        <AdvancedButton
          text={translate(
            'COMPONENTS.PIX_PORTABILITY_MODAL.PENDING_CLAIM_CONFIRM.BUTTON.CANCEL'
          )}
          variant="text"
          onClick={() => setVisible(false)}
        />
      </div>
    </Modal>
  );
};

export default KeyPortabilityModal;
